module.exports = __webpack_public_path__ + "static/media/clock.d90c0c27.svg";